export const AnchorList = [
  '*Набор тестов:',
  'Синонимы русские',
  'Синонимы английские',
  'Метод исследования',
  'Единицы измерения',
  'Какой биоматериал можно использовать для исследования?',
  'Как правильно подготовиться к исследованию?',
  'Как подготовиться к исследованию?',
  'Общая информация об исследовании',
  'Для чего используется исследование?',
  'Когда назначается исследование?',
  'Что означают результаты?',
  'Что может влиять на результат?',
  'Важные замечания',
  'Также рекомендуется',
  'Кто назначает исследование?',
  'Симптомы',
  'Кто в группе риска?',
  'Общая информация о заболевании',
  'Диагностика',
  'Лечение',
  'Профилактика',
  'Название гена',
  'Локализация гена на хромосоме',
  'Функция гена',
  'Генетический маркер',
  'Частота встречаемости в популяции',
  'Ассоциация маркера с заболеваниями',
  'Описание',
  'Интерпретация результатов',
  'Диагностическая значимость',
  'Исследование рекомендуется проводить в комплексе',
  'Литература',
  'Рекомендуемые анализы',
];
